import { AutogenLayoutGLDistributionTableMultiSource } from "./autogen/AutogenLayoutGLDistributionTableMultiSource";
import { Currency, CurrencySettings } from "@mcleod/core";

export class GLDistributionTableMultiSource extends AutogenLayoutGLDistributionTableMultiSource {
    private _displayCompanyColumn: boolean = false;
    private _displayCustomerColumn: boolean = false;
    private _displayDescriptionColumn: boolean = false;
    private _displayInvoiceColumn: boolean = false;
    private _displayOrderColumn: boolean = false;
    private _displayFunctionalAmountColumn: boolean = false;
    private isMultiCurrencyEnabled: boolean = false;

    override onLoad(): void {
        const currencySettings = CurrencySettings.getSingleton();
        this.isMultiCurrencyEnabled = currencySettings.multiCurrencyEnabled();
        this._displayFunctionalAmountColumn = this.isMultiCurrencyEnabled;

        this.syncColumns();

        // Also add a row display listener to update functional amounts when rows are displayed
        this.tableGLDistribution.addRowDisplayListener((event) => {
            if (!this.isMultiCurrencyEnabled) {
                return;
            }
            const tableRow = event.getTableRow();
            const row = tableRow.data;
            const transAmtData = row.get("amount");
            if (transAmtData) {
                // Convert to Currency object if it's not already
                const transAmt = transAmtData instanceof Currency ? transAmtData : new Currency(transAmtData);
                const baseAmount = transAmt.getBaseAmountSimple() ?? transAmt.base_amount;

                if (baseAmount != null) {
                    const functionalCurrency = new Currency({
                        amount: baseAmount,
                        currency_code: CurrencySettings.getFunctionalCurrency(),
                        conversion_date: transAmt.conversion_date,
                        base_amount: baseAmount
                    });
                    row.set("functional_amount", functionalCurrency);
                }
            }
        });
    }

    public set displayCompanyColumn(value: boolean) {
        if (value !== this._displayCompanyColumn) {
            this._displayCompanyColumn = value;
            this.syncColumns();
        }
    }

    public set displayFunctionalAmountColumn(value: boolean) {
        if (!this.isMultiCurrencyEnabled) {
            return;
        }

        if (value !== this._displayFunctionalAmountColumn) {
            this._displayFunctionalAmountColumn = value;
            this.syncColumns();
        }
    }

    public set displayCustomerColumn(value: boolean) {
        if (value !== this._displayCustomerColumn) {
            this._displayCustomerColumn = value;
            this.syncColumns();
        }
    }

    public set displayDescriptionColumn(value: boolean) {
        if (value !== this._displayDescriptionColumn) {
            this._displayDescriptionColumn = value;
            this.syncColumns();
        }
    }

    public set displayInvoiceColumn(value: boolean) {
        if (value !== this._displayInvoiceColumn) {
            this._displayInvoiceColumn = value;
            this.syncColumns();
        }
    }

    public set displayOrderColumn(value: boolean) {
        if (value !== this._displayOrderColumn) {
            this._displayOrderColumn = value;
            this.syncColumns();
        }
    }

    private syncColumns(): void {
        const columnsConfig = [
            { id: "columnHeaderCompany", visible: this._displayCompanyColumn },
            { id: "columnHeaderFunctionalAmount", visible: this._displayFunctionalAmountColumn },
            { id: "columnHeaderCustomer", visible: this._displayCustomerColumn },
            { id: "columnHeaderDescription", visible: this._displayDescriptionColumn },
            { id: "columnHeaderInvoiceNumber", visible: this._displayInvoiceColumn },
            { id: "columnHeaderOrderNumber", visible: this._displayOrderColumn }
        ];

        columnsConfig.forEach(config => {
            const column = this.tableGLDistribution.columns.find(c => c.headingCell.id === config.id);
            if (column) {
                this.tableGLDistribution.setColumnVisibility(column, config.visible);
            }
        });
    }
}
